import {
  CLOSE_CREATE_EVENTSLIST,
  OPEN_CREATE_EVENTSLIST,
  SET_SEARCH_TERM,
  SET_EVENTSLIST_PENDING,
  SET_EVENTSLIST,
  SET_CREATE_NEW_EVENT_SUCCESS,
  SET_NEW_EVENT_ID,
  SET_ADDED_QUESTIONS_LIST,
  SET_NEWEVENT_DATA,
  SET_QUESTIONS_REDIRECT,
  SET_EDIT_QUESTION_DATA,
  REDIRECT_TO_ADD_QUESTION,
  SET_IS_GET_ADDED_QUESTION_LIST_PENDING,
  SET_IS_GET_EVENT_DATA_PENDING,
  SET_IS_GET_EDIT_QUESTION_DATA_PENDING,
  SET_IS_CREATE_NEW_EVENT_PENDING,
  SET_IS_ADD_QUESTION_DATA_PENDING,
  OPEN_ADD_ORGANIZER,
  CLOSE_ADD_ORGANIZER,
  SET_USER_ORGANIZER,
  SET_ORGANIZER_PENDING,
  SET_ORGANIZER_LIST,
  SET_EVENT_ORGANIZER_PENDING,
  OPEN_ADD_EVALUATOR,
  CLOSE_ADD_EVALUATOR,
  GET_EVENT_USERS_PENDING,
  SET_EVENT_USERS,
  SET_EVALUATORS_PENDING,
  SET_EVALUATORS_LIST,
  SET_USER_EVALUATOR,
  SET_EVENT_EVALUATORS_PENDING,
  SET_DELETE_ORGANIZER_PENDING,
  SET_DELETE_EVALUATOR_PENDING,
  SET_UPLOAD_ANSWERVI_VISIBLE,
  SET_AUTOEVAL_RESULTS,
  SET_AUTOEVAL_RESULTS_PENDING,
  SET_CURRENT_QUESTIONID,
  SET_AUTOEVAL_INPUTS_VISIBLE,
  SET_UPLOAD_ANSWER_PENDING,
  INITIALIZE_EDITQUESTIONDATA,
  SET_SAVE_TESTCASE,
  SET_EVENT_EDITED_STATUS,
  SET_IS_EVALUATED,
  SET_CONFIG_FILE_PENDING,
  SET_SAVEFILES_PENDING,
  SET_GAME_DATA_PENDING,
  SET_GAME_DATA,
  SET_GAME_TITLECARD_PENDING,
  SET_GAME_TITLECARD,
  OPEN_INSTRUCTIONS_MODAL,
  CLOSE_INSTRUCTIONS_MODAL,
  SET_UPLOAD_TITLCARD_PENDING,
  SET_UPLOAD_PLUGIN_PENDING,
  SET_UPLOAD_ENGINE_PENDING,
  SET_UPLOAD_PLAYERVI_PENDING,
  SET_UPLOAD_OPPPLAYERVI_PENDING,
  SET_SAVEGAMESETAILS_PENDING,
  SET_EXECUTEGAME_PENDING,
  SET_SHOW_GAME,
  SET_DOWNLOAD_ENGINE_URL
} from "../constants/CreateEvents.constants";
import agent from "../../services/agent";
import {showSnackbarStatus } from "./snackbar.actions";
import { getToken } from "../../helpers/common";

export const setEventEdited = (data): Action =>({
    type:SET_EVENT_EDITED_STATUS,
    payload:data
})

export const setEventEditedStatus = (data) => (dispatch: Function) => {
  dispatch(setEventEdited(data));
}

export const setEvaluatedStatus = (data): Action => ({
  type: SET_IS_EVALUATED,
  payload: data
})

export const openCreateEventsList = (): Action => ({
  type: OPEN_CREATE_EVENTSLIST,
});

export const setAutoEvalResultsPending = (data): Action => ({
  type: SET_AUTOEVAL_RESULTS_PENDING,
  payload: data,
});

export const setTestCaseSavePending=(data): Action => ({
  type: SET_SAVE_TESTCASE,
  payload: data
})

export const setAutoEvalResults = (data): Action => ({
  type: SET_AUTOEVAL_RESULTS,
  payload: data,
});

export const setUploadAnswerVIVisible = (data): Action => ({
  type: SET_UPLOAD_ANSWERVI_VISIBLE,
  payload: data,
});

export const closeCreateEventsList = (): Action => ({
  type: CLOSE_CREATE_EVENTSLIST,
});
export const setSearchTerm = (data): Action => ({
  type: SET_SEARCH_TERM,
  payload: data,
});
export const setEventsListPending = (data): Action => ({
  type: SET_EVENTSLIST_PENDING,
  payload: data,
});
export const setEventsList = (eventsList: any): Action => ({
  type: SET_EVENTSLIST,
  payload: { eventsList },
});

export const setNewEventId = (newEventID: any): Action => ({
  type: SET_NEW_EVENT_ID,
  payload: { newEventID },
});

export const setCreateNewEventSuccess = (neweventCreated): Action => ({
  type: SET_CREATE_NEW_EVENT_SUCCESS,
});

export const setAddedQuestionsList = (data): Action => ({
  type: SET_ADDED_QUESTIONS_LIST,
  payload: data,
});

export const setNewEventData = (data): Action => ({
  type: SET_NEWEVENT_DATA,
  payload: data,
});

export const setQuestionsRedirect = (data): Action => ({
  type: SET_QUESTIONS_REDIRECT,
  payload: data,
});

export const initializeEditQuestionData=(): Action =>({
  type:INITIALIZE_EDITQUESTIONDATA,
})

export const initEditQuestionData = () => (dispatch: Function) => {
    dispatch(initializeEditQuestionData());
}

export const setEditQuestionData = (editQuestionData: any): Action => ({
  type: SET_EDIT_QUESTION_DATA,
  payload: editQuestionData,
});

export const redirectToAddQuestion = (data): Action => ({
  type: REDIRECT_TO_ADD_QUESTION,
  payload: data,
});

export const setIsGetAdddedQuestionListPending = (data): Action => ({
  type: SET_IS_GET_ADDED_QUESTION_LIST_PENDING,
  payload: data,
});

export const setIsGetEventDataPending = (data): Action => ({
  type: SET_IS_GET_EVENT_DATA_PENDING,
  payload: data,
});

export const setIsGetEditQuestionDataPending = (data): Action => ({
  type: SET_IS_GET_EDIT_QUESTION_DATA_PENDING,
  payload: data,
});

export const setIsCreateNewEventPending = (data): Action => ({
  type: SET_IS_CREATE_NEW_EVENT_PENDING,
  payload: data,
});

export const setIsAddQuestionDataPending = (data): Action => ({
  type: SET_IS_ADD_QUESTION_DATA_PENDING,
  payload: data,
});

export const openAddorganizer = (): Action => ({
  type: OPEN_ADD_ORGANIZER,
  payload: true,
});

export const closeAddorganizer = (): Action => ({
  type: CLOSE_ADD_ORGANIZER,
  payload: false,
});

export const setUserOrganizer = (data): Action => ({
  type: SET_USER_ORGANIZER,
  payload: data,
});

export const setOrganizersPending = (data): Action => ({
  type: SET_ORGANIZER_PENDING,
  payload: data,
});

export const setOrganizersList = (data): Action => ({
  type: SET_ORGANIZER_LIST,
  payload: data,
});

export const setEventOrganizersPending = (data): Action => ({
  type: SET_EVENT_ORGANIZER_PENDING,
  payload: data,
});

export const openAddEvaluator = (): Action => ({
  type: OPEN_ADD_EVALUATOR,
  payload: true,
});

export const closeAddEvaluator = (): Action => ({
  type: CLOSE_ADD_EVALUATOR,
  payload: false,
});

export const getEventUsersPending = (data): Action => ({
  type: GET_EVENT_USERS_PENDING,
  payload: data,
});

export const setEventUsers = (data): Action => ({
  type: SET_EVENT_USERS,
  payload: data,
});

export const setEvaluatorsPending = (data): Action => ({
  type: SET_EVALUATORS_PENDING,
  payload: data,
});

export const setEvaluatorsList = (data): Action => ({
  type: SET_EVALUATORS_LIST,
  payload: data,
});

export const setUserEvaluator = (data): Action => ({
  type: SET_USER_EVALUATOR,
  payload: data,
});

export const setEventEvaluatorPending = (data): Action => ({
  type: SET_EVENT_EVALUATORS_PENDING,
  payload: data,
});

export const setDeleteOrganizerPending = (data): Action => ({
  type: SET_DELETE_ORGANIZER_PENDING,
  payload: data,
});

export const setDeleteEvaluatorPending = (data): Action => ({
  type: SET_DELETE_EVALUATOR_PENDING,
  payload: data,
});

export const setAutoEvalInputsVisibility = (data): Action => ({
    type: SET_AUTOEVAL_INPUTS_VISIBLE,
    payload: data,
});

export const setUploadAnswerPending = (data): Action => ({
    type: SET_UPLOAD_ANSWER_PENDING,
    payload: data,
});

export const setConfigFilePending = (data): Action => ({
  type: SET_CONFIG_FILE_PENDING,
  payload: data
});

export const setSaveGameFilesPending = (data): Action => ({
  type: SET_SAVEFILES_PENDING,
  payload: data,
});

export const getGameDataPending = (data): Action => ({
  type: SET_GAME_DATA_PENDING,
  payload: data,
});

export const setGameData = (data): Action => ({
  type: SET_GAME_DATA,
  payload: data,
});

export const setGameTitleCardPending = (data): Action => ({
  type: SET_GAME_TITLECARD_PENDING,
  payload: data,
});

export const setGameTitleCard = (data): Action => ({
  type: SET_GAME_TITLECARD,
  payload: data
});

export const handleOpenInstructionsModal = (): Action => ({
  type: OPEN_INSTRUCTIONS_MODAL,
});

export const handleCloseInstructionsModal = (): Action => ({
  type: CLOSE_INSTRUCTIONS_MODAL,
});

export const setUploadTitleCardPending = (data): Action => ({
  type: SET_UPLOAD_TITLCARD_PENDING,
  payload: data
});

export const setUploadPluginPending = (data): Action => ({
  type: SET_UPLOAD_PLUGIN_PENDING,
  payload: data
});

export const setUploadEnginePending = (data): Action => ({
  type: SET_UPLOAD_ENGINE_PENDING,
  payload: data
});

export const setUploadPlayerVIPending = (data): Action => ({
  type: SET_UPLOAD_PLAYERVI_PENDING,
  payload: data
});

export const setUploadOppPlayerVIPending = (data): Action => ({
  type: SET_UPLOAD_OPPPLAYERVI_PENDING,
  payload: data
});

export const setSaveGameDetailsPending = (data): Action => ({
  type: SET_SAVEGAMESETAILS_PENDING,
  payload: data
});

export const setExecuteGamePending = (data): Action => ({
  type: SET_EXECUTEGAME_PENDING,
  payload: data
});

export const setShowGame = (data): Action => ({
  type: SET_SHOW_GAME,
  payload: data
});

export const setDownloadEngineURL = (data): Action => ({
  type: SET_DOWNLOAD_ENGINE_URL,
  payload: data
});

export const SaveTestcases = (testcases) => async (dispatch) =>{
  dispatch(setTestCaseSavePending(true));
  const TIMEOUT_LIMIT = 30000;
  const timeoutPromise = new Promise((_, reject) =>
    setTimeout(() => reject(new Error("API request timeout exceeded 1 minute")), TIMEOUT_LIMIT)
  );

  try {
    const accessToken = await getToken(dispatch);

    const data = await Promise.race([
      agent.Events.SaveTestcases(accessToken, testcases),
      timeoutPromise,
    ]);

    if(data === true){
      dispatch(showSnackbarStatus("Testcases saved!"));
      dispatch(setEventEdited(false));
    }
      
  } catch (err) {
    console.error("Error caught:", err);
    if (err.message === "API request timeout exceeded 1 minute") {
      dispatch(showSnackbarStatus("Saving is taking too long. Please try again later or Refresh the page"));
    } else if (err?.response?.text) {
      dispatch(showSnackbarStatus(`Failed to save: ${err.response.text}`));
    } else {
      dispatch(showSnackbarStatus("Something went wrong during evaluation"));
    }
  } finally {
    dispatch(setTestCaseSavePending(false));
  }
}

export const evaluateTestCase = (testCaseData) => async (dispatch) => {
  dispatch(setAutoEvalResultsPending(true));

  const TIMEOUT_LIMIT = 30000;
  const timeoutPromise = new Promise((_, reject) =>
    setTimeout(() => reject(new Error("API request timeout exceeded 1 minute")), TIMEOUT_LIMIT)
  );

  try {
    const accessToken = await getToken(dispatch);

    const data = await Promise.race([
      agent.Events.evaluateTestCases(accessToken, testCaseData),
      timeoutPromise,
    ]);

    dispatch(setAutoEvalResults(data));
    dispatch(setEventEdited(true));
  } catch (err) {
    console.error("Error caught:", err);
    if (err.message === "API request timeout exceeded 1 minute") {
      dispatch(showSnackbarStatus("Evaluation is taking too long. Please try again later or Refresh the page"));
    } else if (err?.response?.text) {
      dispatch(showSnackbarStatus(`Evaluation failed: ${err.response.text}`));
    } else {
      dispatch(showSnackbarStatus("Something went wrong during evaluation"));
    }
  } finally {
    dispatch(setAutoEvalResultsPending(false));
  }
};

export const uploadAnswerVI =
  (id, file) => async (dispatch: Function, getState) => {
    dispatch(setUploadAnswerPending(true));

    const TIMEOUT_LIMIT = 30000; // 1 minute

    // Function to create a timeout promise
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(
        () => reject(new Error("API request timeout exceeded 1 minute")),
        TIMEOUT_LIMIT
      )
    );

    try {
      const accessToken = await getToken(dispatch);

      // Use Promise.race to race API call against timeout
      const data = await Promise.race([
        agent.Events.uploadAnswerVI(accessToken, id, file),
        timeoutPromise,
      ]);
      if(data)
        dispatch(showSnackbarStatus("Answer VI uploaded"));
      dispatch(setAutoEvalInputsVisibility(data));

    } catch (err) {
      if (err.message === "API request timeout exceeded 1 minute") {
        dispatch(
          showSnackbarStatus(
            "Upload is taking too long. Please try again later or Refresh the page"
          )
        );
      } else if (err?.response) {
        dispatch(
          showSnackbarStatus(`Unable to upload your code: ${err.response.text}`)
        );
      }
    } finally {
        dispatch(setUploadAnswerPending(false));
    }
  };

export const getEventsList = () => (dispatch: Function) => {
  dispatch(setEventsListPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getEventsList(accessToken)
      .then((eventsList) => {
        dispatch(setEventsList(eventsList && eventsList.value));
        dispatch(setEventsListPending(false));
      })
      .catch((err) => {
        dispatch(setEventsListPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(
              `Unable To Get Events List, ${
                err && err.response && err.response.text
              }`
            )
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const createNewEvent = (data) => async (dispatch: Function) => {
  dispatch(setIsCreateNewEventPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.createNewEvent(accessToken, data)
      .then((newEventID) => {
        dispatch(setNewEventId(newEventID.id));
        dispatch(
          showSnackbarStatus(
            `${
              data.id
                ? "Event Updated Succesfully"
                : "Event Created Succesfully"
            }`
          )
        );
        dispatch(setIsCreateNewEventPending(false));
        dispatch(setEventEditedStatus(false));
      })
      .catch((err) => {
        dispatch(setIsCreateNewEventPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const publishEvent = (id: string) => async (dispatch: Function) => {
  getToken(dispatch).then((accessToken) => {
    agent.Events.publishEvent(accessToken, id)
      .then(() => {
        dispatch(showSnackbarStatus(`Event Published`));
        dispatch(getEventsList());
      })
      .catch((err) => {
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(
              `Unable to Publish event, ${
                err && err.response && err.response.text
              }`
            )
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const setCurrentQuestionId = (data): Action => ({
  type: SET_CURRENT_QUESTIONID,
  payload: data.id,
});

export const addQuestionData =
  (data: any, message, evalType) => async (dispatch: Function) => {
    dispatch(setIsAddQuestionDataPending(true));
    getToken(dispatch).then((accessToken) => {
      agent.Events.addQuestion(accessToken, data)
        .then((data) => {
            if(evalType===1){
                agent.Events.getEditQuestionsDataAutoEval(accessToken,data.id)
                .then((data) => {
                    dispatch(setEditQuestionData(data));
                })
            }
            else{
                dispatch(setCurrentQuestionId(data));
            }
          
          dispatch(showSnackbarStatus(message));
          dispatch(setUploadAnswerVIVisible(true));
          dispatch(setIsAddQuestionDataPending(false));
        })
        .catch((err) => {
          dispatch(setIsAddQuestionDataPending(false));
          if (err && err.response && err.response.text) {
            dispatch(
              showSnackbarStatus(
                `Unable to Add Question, ${
                  err && err.response && err.response.text
                }`
              )
            );
          } else {
            dispatch(showSnackbarStatus(`Something Went Wrong`));
          }
        });
    });
  };

export const getEditQuestionData =
  (id) => async (dispatch: Function, getState) => {
    const state = getState();
    var evalType =
      state &&
      state.createEvent &&
      state.createEvent.newEventData &&
      state.createEvent.newEventData.evaluationType;
    dispatch(setIsGetEditQuestionDataPending(true));
    getToken(dispatch).then((accessToken) => {
      let apiCall;

      if (evalType === 1)
        apiCall = agent.Events.getEditQuestionsDataAutoEval(accessToken, id);
      else
        apiCall = agent.Events.getEditQuestionsDataManualEval(accessToken, id);

      apiCall
        .then((data) => {
          dispatch(setEditQuestionData(data));
          dispatch(setIsGetEditQuestionDataPending(false));
          //if (evalType === 1) dispatch(setUploadAnswerVIVisible(true));
        })
        .catch((err) => {
          dispatch(setIsGetEditQuestionDataPending(false));
          if (err && err.response && err.response.text) {
            dispatch(
              showSnackbarStatus(
                `Unable to Get Question data, ${
                  err && err.response && err.response.text
                }`
              )
            );
          } else {
            dispatch(showSnackbarStatus(`Something Went Wrong`));
          }
        });
    });
  };

export const getAddedQuestionsList = (id) => async (dispatch: Function) => {
  dispatch(setIsGetAdddedQuestionListPending(true));
  dispatch(setIsGetEventDataPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getAddedQuestions(accessToken, id)
      .then((data) => {
        dispatch(setAddedQuestionsList(data && data.value));
        dispatch(setIsGetAdddedQuestionListPending(false));
        dispatch(setIsGetEventDataPending(false));
      })
      .catch((err) => {
        dispatch(setIsGetAdddedQuestionListPending(false));
        dispatch(setIsGetEventDataPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(
              `Unable to Get Questions List, ${
                err && err.response && err.response.text
              }`
            )
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const getEventData = (id) => async (dispatch: Function) => {
  dispatch(setIsGetEventDataPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.eventData(accessToken, id)
      .then((data) => {
        dispatch(setNewEventData(data));
        dispatch(getAddedQuestionsList(id));
      })
      .catch((err) => {
        dispatch(setIsGetEventDataPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(
              `Unable to Get Event Data, ${
                err && err.response && err.response.text
              }`
            )
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const deleteEvent = (id) => async (dispatch: Function) => {
  getToken(dispatch).then((accessToken) => {
    agent.Events.deleteEvent(accessToken, id)
      .then((data) => {
        dispatch(showSnackbarStatus(`Event Deleted Successfully`));
        dispatch(getEventsList());
      })
      .catch((err) => {
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(
              `Unable to Delete Event, ${
                err && err.response && err.response.text
              }`
            )
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const deleteQuestion = (id, eventID) => async (dispatch: Function) => {
  getToken(dispatch).then((accessToken) => {
    agent.Events.deleteQuestion(accessToken, id)
      .then((data) => {
        dispatch(showSnackbarStatus(`Question Deleted Successfully`));
        dispatch(getAddedQuestionsList(eventID));
        dispatch(getEventData(eventID));
      })
      .catch((err) => {
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(
              `Unable to Delete Question, ${
                err && err.response && err.response.text
              }`
            )
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const getOrganizersList = (id) => async (dispatch: Function) => {
  dispatch(setOrganizersPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getOrganizersList(accessToken, id)
      .then((data) => {
        dispatch(setOrganizersList(data));
      })
      .catch((err) => {
        dispatch(setOrganizersPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const setEventOrganizer = (data) => async (dispatch: Function) => {
  dispatch(setEventOrganizersPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.setSelectedOrganizer(accessToken, data)
      .then((result) => {
        dispatch(getOrganizersList(data.eventId));
        const dataToSend = {
          eventId: data.eventId,
          isOrganizer: true,
        };
        dispatch(getEventsUserList(dataToSend));
      })
      .catch((err) => {
        dispatch(setEventOrganizersPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const getEventsUserList = (data) => async (dispatch: Function) => {
  dispatch(getEventUsersPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getEventUsers(accessToken, data)
      .then((result) => {
        dispatch(setEventUsers(result));
      })
      .catch((err) => {
        dispatch(getEventUsersPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const getEvaluatorsList = (id) => async (dispatch: Function) => {
  dispatch(setEvaluatorsPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getEvaluatorsList(accessToken, id)
      .then((data) => {
        dispatch(setEvaluatorsList(data));
      })
      .catch((err) => {
        dispatch(setEvaluatorsPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const setEventEvaluator = (data) => async (dispatch: Function) => {
  dispatch(setEventEvaluatorPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.setSelectedEvaluator(accessToken, data)
      .then((result) => {
        dispatch(getEvaluatorsList(data.eventId));
        const dataToSend = {
          eventId: data.eventId,
          isOrganizer: false,
        };
        dispatch(getEventsUserList(dataToSend));
      })
      .catch((err) => {
        dispatch(setEventEvaluatorPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const deleteOrganizer = (data) => async (dispatch: Function) => {
  dispatch(setDeleteOrganizerPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.deleteOrganizer(accessToken, data)
      .then((result) => {
        dispatch(getOrganizersList(data.eventId));
        const dataToSend = {
          eventId: data.eventId,
          isOrganizer: true,
        };
        dispatch(getEventsUserList(dataToSend));
      })
      .catch((err) => {
        dispatch(setDeleteOrganizerPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const deleteEvaluator = (data) => async (dispatch: Function) => {
  dispatch(setDeleteEvaluatorPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.deleteEvaluator(accessToken, data)
      .then((result) => {
        dispatch(getEvaluatorsList(data.eventId));
        const dataToSend = {
          eventId: data.eventId,
          isOrganizer: false,
        };
        dispatch(getEventsUserList(dataToSend));
      })
      .catch((err) => {
        dispatch(setDeleteEvaluatorPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      });
  });
};

export const setConfigFile = (data, id) => async(dispatch: Function) => {
  dispatch(setConfigFilePending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.setConfigFile(accessToken, data, id)
    .then((result) => {
      dispatch(setConfigFilePending(false));
      dispatch(getEventData(id));
    })
    .catch((err) => {
      dispatch(setConfigFilePending(false));
    });
  });
};

export const getGameData = (eventId) => async (dispatch: Function) => {
  dispatch(getGameDataPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getGameData(accessToken, eventId)
      .then((data) => {
        dispatch(setGameData(data));
        dispatch(getGameDataPending(false));
      })
      .catch((err) => {
        dispatch(getGameDataPending(false));
        if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
      })
  })
};

export const getGameTitleCard = (id) => async (dispatch: Function) => {
  dispatch(setGameTitleCardPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getGameTitleCard(accessToken, id)
    .then((data) => {
      const res = URL.createObjectURL(data);
      dispatch(setGameTitleCard(res));
      dispatch(setGameTitleCardPending(false));
    })
    .catch((err) => {
      dispatch(setGameTitleCardPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    });
  });
};

export const uploadTitleCard = (data) => async (dispatch: Function) => {
  dispatch(setUploadTitleCardPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.uploadTitleCard(accessToken, data)
    .then((result) => {
      dispatch(getGameData(data.eventId));
      dispatch(getGameTitleCard(data.eventId));
      dispatch(setUploadTitleCardPending(false));
    })
    .catch((err) => {
      dispatch(setUploadTitleCardPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  });
};

export const uploadReactPlugin = (data) => async (dispatch: Function) => {
  dispatch(setUploadPluginPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.uploadReactPlugin(accessToken, data)
    .then((result) => {
      dispatch(getGameData(data.eventId));
      dispatch(setUploadPluginPending(false));
    })
    .catch((err) => {
      dispatch(setUploadPluginPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const uploadSupportingDocs = (data) => async (dispatch: Function) => {
  dispatch(setUploadPluginPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.uploadSupportingFiles(accessToken, data)
    .then((result) => {
      dispatch(getGameData(data.eventId));
      dispatch(setUploadPluginPending(false));
    })
    .catch((err) => {
      dispatch(setUploadPluginPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const uploadGameEngine = (data) => async (dispatch: Function) => {
  dispatch(setUploadEnginePending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.uploadGameEngine(accessToken, data)
    .then((result) => {
      dispatch(getGameData(data.eventId));
      dispatch(setUploadEnginePending(false));
    })
    .catch((err) => {
      dispatch(setUploadEnginePending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const uploadPlayerVITemplate = (data) => async (dispatch: Function) => {
  dispatch(setUploadPlayerVIPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.uploadPlayerVITemplate(accessToken, data)
    .then((result) => {
      dispatch(getGameData(data.eventId));
      dispatch(setUploadPlayerVIPending(false));
    })
    .catch((err) => {
      dispatch(setUploadPlayerVIPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const uploadSamplePlayerVI = (data) => async (dispatch: Function) => {
  dispatch(setUploadPlayerVIPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.uploadSamplePlayerVI(accessToken, data)
    .then((result) => {
      dispatch(getGameData(data.eventId));
      dispatch(setUploadPlayerVIPending(false));
    })
    .catch((err) => {
      dispatch(setUploadPlayerVIPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const uploadOpponentPlayerVI = (data) => async (dispatch: Function) => {
  const eventId = data.get("eventId");
  dispatch(setUploadOppPlayerVIPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.uploadOpponentPlayerVI(accessToken, data)
    .then((result) => {
      dispatch(getGameData(eventId));
      dispatch(setUploadOppPlayerVIPending(false));
    })
    .catch((err) => {
      dispatch(setUploadOppPlayerVIPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const saveGameDetails = (data) => async (dispatch: Function) => {
  dispatch(setSaveGameDetailsPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.saveGameDetails(accessToken, data)
    .then((result) => {
      dispatch(getGameData(data.eventId));
      dispatch(setSaveGameDetailsPending(false));
    })
    .catch((err) => {
      dispatch(setSaveGameDetailsPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const executeGame = (eventId, oppId, data) => async (dispatch: Function) => {
  dispatch(setExecuteGamePending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.executeGame(accessToken, eventId, oppId)
    .then((result) => {  
      dispatch(setExecuteGamePending(false));                               //to maintain logs in the same state
      let newData = {
        ...data,
        log: result && result.log,
      };
      dispatch(setGameData(newData)); 
      dispatch(setShowGame(true));
    })
    .catch((err) => {
      dispatch(setExecuteGamePending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
}

export const getDownloadEngineURL = () => async (dispatch: Function) => {
  dispatch(setUploadOppPlayerVIPending(true));
  getToken(dispatch).then((accessToken) => {
    agent.Events.getDowloadEngineURL(accessToken)
    .then((result) => {
      // dispatch(setDownloadEngineURL(result));
      const fileUrl = result;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = true;
      link.click();
      dispatch(setUploadOppPlayerVIPending(false));
    })
    .catch((err) => {
      dispatch(setUploadOppPlayerVIPending(false));
      if (err && err.response && err.response.text) {
          dispatch(
            showSnackbarStatus(`${err && err.response && err.response.text}`)
          );
        } else {
          dispatch(showSnackbarStatus(`Something Went Wrong`));
        }
    })
  })
};
